import { Component } from "react";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Modal, InputNumber, Button } from "antd";
import LayoutWrapper from "./LayoutWrapper";
import PackageSearch from "./PackageSearch";

export class B2CPackageConfig extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("B2CPackageConfig");
    this.state = {
      data: [],
      rowcount: 0,
      search: {
        limit: 50,
        page: 1,
        order_by: "updatedAt",
        order_direction: "DESC",
      },
      loader: false,
      isQrModalOpen: false,
      selectedPackageForQr: null,
      no_of_downloads: 1,
      qrDownloading: false,
    };
    this.columns = [
      {
        dataIndex: "package_name",
        title: "Name",
      },
      {
        dataIndex: "scanned",
        title: "# of Ecom Users",
        render: (text, record) => (
          <a
            href="#"
            className="anchorTag"
            onClick={() => this.getScanDetails(record)}
          >
            {record?.scanned?.length}
          </a>
        ),
      },
      {
        dataIndex: "scanned",
        title: "# of BSqC Users",
        render: (text, record) => <a href="#" className="anchorTag"></a>,
      },
      {
        dataIndex: "session_id",
        title: "# of Sessions",
        render: (text, record) => (
          <a
            href="#"
            className="anchorTag"
            onClick={() => this.getSessionDetails(record)}
          >
            {record?.session_id?.length}
          </a>
        ),
      },
      {
        dataIndex: "createdAt",
        title: "Created Date",
        render: (text, record) => {
          if (text) {
            let date = new Date(text).dateToDDMMYYYY(new Date(text));
            return date || "-";
          } else {
            return "-";
          }
        },
      },
      {
        dataIndex: "updatedAt",
        title: "Last Modified Date",
        render: (text, record) => {
          if (text) {
            let date = new Date(text).dateToDDMMYYYY(new Date(text));
            return date;
          } else {
            return "-";
          }
        },
      },
      {
        dataIndex: "status",
        title: "Status",
        render: (text, record) => {
          return (
            <span
              className={`badge light border-0 ${
                record.status?.toTitleCase() === "status"
                  ? "text-primary"
                  : record.status == "DISABLE"
                  ? "badge-danger"
                  : "badge-success"
              } `}
            >
              {record.status?.toTitleCase()}
            </span>
          );
        },
      },
    ];
    this.role = localStorage.getItem("currentAdminRole");
  }

  componentDidMount() {
    this.fetchList();
  }
  getScanDetails(record) {
    this.props.navigate(
      `/businesstoconsumerconfig/scandetails?package_id=${record?.package_id}&package_name=${record?.package_name}`
    );
  }

  getSessionDetails(record) {
    this.props.navigate(
      `/businesstoconsumerconfig/sessions?package_id=${record?.package_id}&package_name=${record?.package_name}`
    );
  }

  addPackageInfo() {
    this.props.navigate(`/businesstoconsumerconfig/configpage`);
  }

  fetchList = (params) => {
    this.setState({ loader: true });
    let payload = {
      ...this.state.search,
      ...params,
    };
    this.props.api.apiGetPackages(payload).then(({ data, total }) => {
      this.setState({
        loader: false,
        data,
        rowcount: total,
      });
    });
  };

  onNext() {}

  onPrev() {}

  onPageChange(pageData) {
    this.setState(
      {
        search: {
          ...this.state.search,
          page: pageData.current,
          limit: pageData.pageSize || pageData.defaultPageSize || 25,
        },
      },
      () => this.fetchList()
    );
  }

  deleteAction(record) {
    confirm(`Do you really want to delete these package?`).promise.then(() => {
      let payload = {
        is_deleted: true,
      };
      this.setState({
        loader: true,
      });
      this.props.api
        .apiUpdatePackage(payload, { package_id: record.package_id })
        .then((res) => {
          success("Package Deleted Successfully");
          this.fetchList();
          this.setState({
            loader: false,
          });
        })
        .catch((err) => {
          this.setState({
            loader: false,
          });
        });
    });
  }

  disableAction(record) {
    let payload = {
      status: record.status === "DISABLE" ? "ENABLE" : "DISABLE",
    };

    let editDataPayload = { ...payload };
    this.props.api
      .apiUpdatePackage(editDataPayload, { package_id: record.package_id })
      .then((res) => {
        this.fetchList();
        this.setState({
          loader: false,
        });
      })
      .catch((err) => {
        this.setState({
          loader: false,
        });
      });
  }

  isDisabled(record) {
    return record.status == "ENABLE" ? "ENABLE" : "DISABLE";
  }

  downloadAction(record) {
    this.setState({
      isQrModalOpen: true,
      selectedPackageForQr: record,
      no_of_downloads: 1,
      qrDownloading: false,
    });
  }

  handleCloseQrModal = () => {
    if (this.state.qrDownloading) return;
    this.setState({
      isQrModalOpen: false,
      selectedPackageForQr: null,
      no_of_downloads: 1,
      qrDownloading: false,
    });
  };

  handleConfirmQrDownload = () => {
    const record = this.state.selectedPackageForQr;
    if (!record) return;

    const no_of_downloads = Math.max(
      1,
      parseInt(this.state.no_of_downloads, 10) || 1
    );

    this.setState({
      qrDownloading: true,
    });

    this.props.api
      .apiGetPackageQRCode(
        { package_id: record?.package_id },
        { package_id: record?.package_id, no_of_downloads }
      )
      .then(async (res) => {
        if (res) {
          this.setState({
            qrDownloading: false,
            isQrModalOpen: false,
            selectedPackageForQr: null,
          });

          let apiRes = await res;
          const isZip =
            no_of_downloads >= 2 ||
            apiRes?.filename?.toLowerCase().endsWith(".zip");
          const mimeType = isZip ? "application/zip" : "application/pdf";
          const ext = isZip ? "zip" : "pdf";
          const safePackageName = (
            record?.package_name || "package_qr"
          ).replace(/[^a-zA-Z0-9_-]/g, "_");
          const fallbackFilename = `${safePackageName}${
            no_of_downloads > 1 ? `_${no_of_downloads}_copies` : ""
          }.${ext}`;
          const downloadFilename = apiRes?.filename || fallbackFilename;

          let blob;
          if (apiRes?.data instanceof Blob) {
            blob = apiRes.data.type
              ? apiRes.data
              : new Blob([apiRes.data], { type: mimeType });
          } else {
            blob = new Blob([apiRes?.data], { type: mimeType });
          }

          let link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", downloadFilename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);

          success("QR Downloaded Successfully");
        } else {
          this.setState({
            qrDownloading: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          qrDownloading: false,
        });
      });
  };

  downloadBsqcAction(record) {
    this.setState({
      loader: true,
    });
    this.props.api
      .apiGetPackageQRCodeForBsqc({ package_id: record?.package_id })
      .then(async (res) => {
        if (res) {
          this.setState({
            loader: false,
          });

          let apiRes = await res;
          let blob = new Blob([apiRes?.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", apiRes?.filename);
          link.click();

          success("QR Downloaded Successfully");
        }
      })
      .catch((err) => {
        this.setState({
          loader: false,
        });
      });
  }
  downloadBase64Image(base64, fileName) {
    const link = document.createElement("a");
    link.href = base64;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  editAction(v) {
    console.log("edit: ", v);
    this.props.navigate(
      `/businesstoconsumerconfig/configpage?package_id=${v.package_id}&package_name=${v.package_name}`
    );
  }

  viewAction(v) {
    console.log("view: ", v);
    this.props.navigate(
      `/businesstoconsumerconfig/configpage?package_id=${v.package_id}&package_name=${v.package_name}&readonly=true`
    );
  }

  onSearch(data) {
    console.log("onSearch data: ", data);
    let searchPayload = {};
    if (Object.keys(data).length === 0) {
      searchPayload = { ...this.state.search };
    } else {
      searchPayload = { ...this.state.search, ...data };
    }
    this.fetchList(searchPayload);
  }

  render() {
    let { data = [], rowcount, loader } = this.state;
    let { columns } = this;

    return (
      <>
        {loader && (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        )}
        <ToastContainer position="top-right" />

        <LayoutWrapper
          title="B2C Package Configuration"
          back="B2C Package Configuration"
        >
          <div>
            <div className="row">
              <div className="col"></div>
              {localStorage.getItem("currentAdminRole") == "SUPER_ADMIN" && (
                <div className="mb-4">
                  <Link
                    className="btn add-btn"
                    onClick={() => this.addPackageInfo()}
                  >
                    <i className="fa fa-plus"></i>
                    Add Package
                  </Link>
                </div>
              )}
            </div>
            <div className="row mb-3">
              <div className="col">
                <PackageSearch
                  inactive={() => {
                    console.log(this.props.inactive);
                    return this.props.inactive;
                  }}
                  onSearch={(...arg) => this.onSearch(...arg)}
                />
              </div>
            </div>
            <div className="row schoolmanagement">
              <div className="col-12">
                {!!data.length && (
                  <AppTable
                    data={data}
                    columns={columns}
                    onNext={() => this.onNext()}
                    onPrev={() => this.onPrev()}
                    onChange={(...arg) => this.onPageChange(...arg)}
                    total={rowcount}
                    reorder={true}
                    {...(localStorage.getItem("currentAdminRole") ==
                    "B2C_FULLFILLMENT"
                      ? {
                          editable: false,
                          deletable: false,
                          disableable: false,
                        }
                      : {
                          disableable: true,
                        })}
                    deleteAction={(v) => this.deleteAction(v)}
                    editAction={(v) => this.editAction(v)}
                    viewAction={(v) => this.viewAction(v)}
                    downloadAction={(v) => this.downloadAction(v)}
                    downloadBsqcAction={(v) => this.downloadBsqcAction(v)}
                    disableAction={(v) => this.disableAction(v)}
                    isDisabled={(v) => this.isDisabled(v)}
                    targetType="tap"
                    isresponsive={false}
                    downloadableBsqc={true}
                    downloadable={true}
                  ></AppTable>
                )}
                {data.length == 0 && <div className="empty_layout"></div>}
              </div>
            </div>
          </div>
        </LayoutWrapper>

        <Modal
          title={
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <i
                className="fa fa-qrcode text-primary"
                style={{ fontSize: "18px" }}
              ></i>
              <span style={{ fontWeight: 600, fontSize: "16px" }}>
                Download Package QR
              </span>
            </div>
          }
          visible={this.state.isQrModalOpen}
          onCancel={this.handleCloseQrModal}
          footer={[
            <Button
              key="cancel"
              onClick={this.handleCloseQrModal}
              disabled={this.state.qrDownloading}
            >
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={this.state.qrDownloading}
              onClick={this.handleConfirmQrDownload}
              className="btn-primary"
              style={{ minWidth: "100px" }}
            >
              Download
            </Button>,
          ]}
          centered
          destroyOnClose
          width={460}
          zIndex={1060}
          maskClosable={!this.state.qrDownloading}
        >
          <div style={{ padding: "4px 0" }}>
            {this.state.selectedPackageForQr && (
              <div
                className="mb-3 p-2 px-3 rounded"
                style={{
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #e9ecef",
                }}
              >
                <div
                  style={{
                    fontSize: "11px",
                    color: "#6c757d",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    fontWeight: 600,
                  }}
                >
                  Selected Package
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#212529",
                    marginTop: "2px",
                  }}
                >
                  {this.state.selectedPackageForQr?.package_name || "N/A"}
                </div>
              </div>
            )}

            <div className="form-group mb-2">
              <label
                className="form-label fw-semibold"
                style={{
                  marginBottom: "6px",
                  display: "block",
                  fontSize: "13px",
                }}
              >
                Number of Downloads / Copies{" "}
                <span className="text-danger">*</span>
              </label>
              <InputNumber
                min={1}
                max={1000}
                precision={0}
                value={this.state.no_of_downloads}
                onChange={(val) => this.setState({ no_of_downloads: val })}
                onPressEnter={this.handleConfirmQrDownload}
                style={{
                  width: "100%",
                  height: "38px",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                }}
                placeholder="Enter number of downloads"
              />
            </div>

            <div
              className="mt-3 p-2 rounded"
              style={{
                backgroundColor:
                  Number(this.state.no_of_downloads) >= 2
                    ? "#e8f4fd"
                    : "#f8f9fa",
                border: `1px solid ${
                  Number(this.state.no_of_downloads) >= 2
                    ? "#b6d4fe"
                    : "#dee2e6"
                }`,
                fontSize: "12px",
                lineHeight: "1.4",
              }}
            >
              {Number(this.state.no_of_downloads) >= 2 ? (
                <div style={{ color: "#084298" }}>
                  <i
                    className="fa fa-file-archive-o me-2"
                    style={{ marginRight: "6px" }}
                  ></i>
                  Will download a <strong>ZIP file</strong> containing separate
                  PDFs for each copy.
                </div>
              ) : (
                <div style={{ color: "#495057" }}>
                  <i
                    className="fa fa-file-pdf-o me-2 text-danger"
                    style={{ marginRight: "6px" }}
                  ></i>
                  Will download directly as a single <strong>PDF</strong>.
                </div>
              )}
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
export default connect(B2CPackageConfig);
